import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10.125",
  height: "6.123"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "data-name": "Arrow – down- 4x8" }, [
      _createElementVNode("path", {
        fill: "none",
        stroke: "#626997",
        "stroke-linecap": "square",
        "stroke-width": "1.5",
        d: "m9.063 1.063-4 4-4-4",
        "data-name": "Path 5800"
      })
    ], -1)
  ]))]))
}
export default { render: render }